/** Точка входа: монтирует React-приложение в DOM. */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/api";
import { restoreAuthSession } from "@/shared/store";
import { AppErrorBoundary } from "./ui/AppErrorBoundary";
import { router } from "./router";
import { showScrollbarsWhileScrolling } from "./scrollbars";
import "./styles/index.css";
import "react-toastify/dist/ReactToastify.css";

const container = document.getElementById("root");
if (!container) throw new Error("Не найден элемент #root");

showScrollbarsWhileScrolling();

await restoreAuthSession();

const app = (
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<AppErrorBoundary>
				<RouterProvider router={router} />
			</AppErrorBoundary>
		</QueryClientProvider>
	</StrictMode>
);

createRoot(container).render(app);
